import apiClient from "./apiClient";

export async function listCustomerTypes(companyId: string) {
  const response = await apiClient.get(
    `/api/companies/${companyId}/customer-types`,
  );
  return response.customerTypes || [];
}

export async function getCustomerType(companyId: string, id: string) {
  const response = await apiClient.get(
    `/api/companies/${companyId}/customer-types/${id}`,
  );
  return response.customerType;
}

export async function createCustomerType(
  companyId: string,
  data: { name: string; description?: string },
) {
  const response = await apiClient.post(
    `/api/companies/${companyId}/customer-types`,
    data,
  );
  return response.customerType;
}

export async function updateCustomerType(
  companyId: string,
  id: string,
  updates: { name?: string; description?: string },
) {
  const response = await apiClient.put(
    `/api/companies/${companyId}/customer-types/${id}`,
    updates,
  );
  return response.customerType;
}

export async function deleteCustomerType(companyId: string, id: string) {
  const response = await apiClient.delete(
    `/api/companies/${companyId}/customer-types/${id}`,
  );
  return response.customerType;
}

const customerTypesService = {
  listCustomerTypes,
  getCustomerType,
  createCustomerType,
  updateCustomerType,
  deleteCustomerType,
};

export default customerTypesService;
